import { action } from "typesafe-actions";

import ISelectOption from "../../xhr/interface/ISelectOption";
import ActionTypes from "./ProjectSelectboxActionTypesEnum";

export const loadProjectSelectboxSuccess = (projectData: ISelectOption[]) =>
    action(ActionTypes.LOAD_SUCCESS, projectData);
export const loadProjectSelectboxError = (error: any) => action(ActionTypes.LOAD_ERROR, error);
